import { ModuleWithProviders, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { AppvizerUrlService, DatoCmsService, MagazineUrlService } from "./services";
import { AutocompleteComponent, SearchEntityService } from "./components";
import { HighlightPipe } from "./pipes";

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  declarations: [HighlightPipe, AutocompleteComponent],
  exports: [HighlightPipe, AutocompleteComponent]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        AppvizerUrlService,
        MagazineUrlService,
        DatoCmsService,
        SearchEntityService
      ]
    };
  }
}
